import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { UserDataProvider } from "../../data-provider/user.dp";
import { AppointmentDataProvider } from "../../data-provider/appointment.dp";
import { Appointment } from "../../models/appointment.model";
import { User } from "../../models/user.model";
import { AppointmentsHelper } from "./appointments.helper";
import { PermissionCheck } from "../../shared/permission";

let AppointmentFormComponent = {
    selector: "vcAppointmentForm",
    templateUrl: "/angular/components/planner/appointment-form.component.html",
    bindings: {
        selectedAppointment: "=?",
        canvass: "=?",
    },
    controller: class AppointmentFormController {
        // * bindings for typescript compiler *
        public selectedAppointment: Appointment;
        public canvass?: any;
        // ************************************

        private errors: any = {};
        public saving: boolean = false;
        public dateLocale: any = false;

        private $scope: any;
        private $filter: any;
        private toast: ToastUtils;
        private __env: any;
        private __time_zone: any;
        private modelsUtils: any;
        private dialog: DialogUtils;
        public helper: AppointmentsHelper;
        public permissionProvider: PermissionCheck;
        public hasEditPermission: boolean;

        private dataProvider: AppointmentDataProvider;

        public use24hr: boolean = false;
        public periods: string[];
        public hours: number[];
        public readonly minutes = [
            "00",
            "05",
            10,
            15,
            20,
            25,
            30,
            35,
            40,
            45,
            50,
            55,
        ];
        public readonly days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];

        public today: Date;
        public start: any;

        private preferencesService: any;

        constructor(
            $scope: any,
            $filter: any,
            __time_zone: any,
            __env: any,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            ModelsUtils: any,
            AppointmentDataProvider: AppointmentDataProvider,
            AppointmentsHelper: AppointmentsHelper,
            PermissionCheck: PermissionCheck,
            PreferencesService: any
        ) {
            this.$scope = $scope;
            this.$filter = $filter;
            this.toast = ToastUtils;
            this.__env = __env;
            this.__time_zone = __time_zone;
            this.modelsUtils = ModelsUtils;
            this.dialog = DialogUtils;

            this.dataProvider = AppointmentDataProvider;
            this.permissionProvider = PermissionCheck;
            this.helper = AppointmentsHelper;
            this.preferencesService = PreferencesService;
            this.use24hr = PreferencesService.use24Hour();
            this.periods = this.use24hr ? [""] : ["am", "pm"];
            this.hours = this.use24hr
                ? [
                      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                      17, 18, 19, 20, 21, 22, 23,
                  ]
                : [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            this.today = new Date();

            this.dateLocale = {
                formatDate: (date: string) => {
                    let dateObj: Date = new Date(date);

                    if (dateObj.getFullYear() > 1971) {
                        return this.$filter("date")(dateObj, "MMM dd, yyyy");
                    }
                    return null;
                },
            };
        }

        $onInit() {
            if (
                this.selectedAppointment &&
                this.selectedAppointment.appointmenttime &&
                typeof this.selectedAppointment.appointmenttime == "string"
            ) {
                this.selectedAppointment.appointmenttime = new Date(
                    this.selectedAppointment.appointmenttime
                );
            }

            if (this.canvass) {
                if (this.canvass.appointment) {
                    if (
                        this.canvass.appointment.appointmenttime &&
                        typeof this.canvass.appointment.appointmenttime ==
                            "string"
                    ) {
                        this.canvass.appointment.appointmenttime = new Date(
                            this.canvass.appointment.appointmenttime
                        );
                    }

                    this.selectedAppointment = this.modelsUtils.appointment(
                        this.canvass.appointment
                    );
                } else {
                    let name: string = "Appointment";

                    if (this.canvass.houseoccupant) {
                        this.canvass.houseoccupant =
                            this.modelsUtils.houseOccupant(
                                this.canvass.houseoccupant
                            );
                        name +=
                            " with " + this.canvass.houseoccupant.identifier();
                    } else if (this.canvass.house) {
                        name += " at " + this.canvass.house.address();
                    }

                    this.selectedAppointment = this.modelsUtils.appointment({
                        assignee: !!this.canvass.cscanvasser
                            ? this.canvass.cscanvasser
                            : null,
                        contact: !!this.canvass.houseoccupant
                            ? this.canvass.houseoccupant
                            : null,
                        house: !!this.canvass.house ? this.canvass.house : null,
                        appointmenttime: null,
                        name: name,
                    });
                    this.start = {
                        date: null,
                        time: { model: null },
                    };
                }
            }
            if (!this.selectedAppointment.appointmenttime) {
                this.start.time = {
                    hours: 9,
                    minutes: "00",
                    period: this.use24hr ? "" : "am",
                };
            }
            this.initializeTime();

            this.hasEditPermission = this.helper.hasPermissionToChange(
                this.selectedAppointment,
                "EDIT_APPOINTMENTS"
            );
        }

        initializeTime(): void {
            if (this.selectedAppointment.appointmenttime) {
                const date: Date = new Date(
                    this.selectedAppointment.appointmenttime
                );
                let startHour: number = date.getHours();
                const mins: number = date.getMinutes();
                const leftOverMinutes: number = mins % 5;
                let startMins =
                    leftOverMinutes != 0
                        ? mins == 0
                            ? "00"
                            : mins + 5 - (mins % 5)
                        : mins.toString();

                if (startMins == 60) {
                    startMins = "00";
                    startHour++;
                } else if (startMins == 0) {
                    startMins = "00";
                } else if (startMins == 5) {
                    startMins = "05";
                }

                if (
                    this.selectedAppointment.id ||
                    (this.canvass && this.canvass.appointment)
                ) {
                    if (this.use24hr) {
                        this.start = {
                            date: _.cloneDeep(date),
                            time: {
                                period: "",
                                hours: startHour,
                                minutes: startMins,
                                model:
                                    (startHour < 10
                                        ? "0" + startHour
                                        : startHour) +
                                    ":" +
                                    startMins,
                            },
                        };
                    } else {
                        let startHourModel =
                            startHour > 12 ? startHour - 12 : startHour;
                        let startPeriod = startHour >= 12 ? "pm" : "am";

                        if (startHourModel == 0) {
                            startHourModel = 12;
                        }

                        this.start = {
                            date: _.cloneDeep(date),
                            time: {
                                period: startPeriod,
                                hours: startHourModel,
                                minutes: startMins,
                                model:
                                    startHourModel +
                                    ":" +
                                    startMins +
                                    startPeriod,
                            },
                        };
                    }

                    this.timeChanged();
                }
            }
        }

        timeChanged(): void {
            if (!this.start) {
                this.start = {
                    date: null,
                    time: { model: null },
                };
            }

            if (!this.start.time) this.start.time = {};
        }

        dateChanged(obj: any): void {}

        openCanvassDialog(canvass: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-canvass-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedHouseOccupant: null,
                        selectedHouse: null,
                        selectedCanvass: canvass,
                    },
                    size: "x-large",
                    ariaLabel: "Interaction",
                })
                .then((data) => _.merge(canvass, data));
        }
        toggleStatus(): void {
            if (this.selectedAppointment.isComplete()) {
                this.selectedAppointment.status = "Active";
            } else {
                this.selectedAppointment.status = "Done";
            }
        }

        openDate(ev: any): void {
            this.dialog
                .show({
                    component: "vc-appointment-date",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        date: angular.copy(
                            this.selectedAppointment.appointmenttime
                        ),
                    },
                    size: "med",
                    ariaLabel: "Appointment Date",
                })
                .then((date: any) => {
                    this.selectedAppointment.appointmenttime = date.date;
                });
        }

        dismissDialog(): void {
            this.dialog.cancel();
        }

        openDeleteDialog(ev: any): void {
            if (this.selectedAppointment.id) {
                this.dialog
                    .delete({
                        targetEvent: ev,
                        multiple: true,
                        locals: {
                            title: "Delete Appointment?",
                        },
                    })
                    .then(() => {
                        this.dataProvider.delete(this.selectedAppointment).then(
                            (appointment: any) => {
                                this.dialog.hide(null);
                            },
                            (error: object) => {
                                this.toast.error(error);
                                console.log(error);
                            }
                        );
                    });
            } else {
                this.dialog.hide(null);
            }
        }
        saveAppointment(): void {
            this.saving = true;

            let hour = this.start.time.hours;
            if (!this.use24hr) {
                if (hour === 12) {
                    hour = 0;
                }
                if (this.start.time.period === "pm" && hour < 13) {
                    hour = hour + 12;
                }
            }

            this.selectedAppointment.appointmenttime.setHours(
                hour,
                this.start.time.minutes,
                0,
                0
            );

            if (this.selectedAppointment.id) {
                this.dataProvider.update(this.selectedAppointment).then(
                    (appointment: any) => {
                        this.dialog.hide(this.selectedAppointment);
                    },
                    (error: object) => {
                        this.saving = false;
                        this.toast.error(error);
                        console.log(error);
                    }
                );
            } else {
                this.dialog.hide(this.selectedAppointment);
            }
        }
    },
};

angular
    .module("planner")
    .component(AppointmentFormComponent.selector, AppointmentFormComponent);
